import React from 'react';
import { SVGIconProps } from '../../domains/common';

const SearchConsoleIcon: React.FC<SVGIconProps> = ({ colored, ...rest }) => {
  return (
    <svg
      width="2em"
      height="2em"
      viewBox="0 0 22 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_1904_57857)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.72949 2.00121L8.51328 0.00145459V3.81917H6.72949V2.00121ZM17.27 2.00121L15.4862 0.00145459V3.81917H17.27V2.00121Z"
          fill={colored ? 'rgb(123, 123, 123)' : '#36526E'}
        />
        <path
          d="M8.51367 0.00145459H15.4866V1.91031H8.51367V0.00145459Z"
          fill={colored ? 'rgb(90, 90, 90)' : '#36526E'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.0541 23.9985H1.94595C1.42985 23.9985 0.93489 23.7687 0.569954 23.3596C0.205019 22.9505 0 22.3956 0 21.817L0 7.56763L3.34362 3.81917H20.6564L24 7.56763V21.817C24 22.3956 23.795 22.9505 23.43 23.3596C23.0651 23.7687 22.5701 23.9985 22.0541 23.9985Z"
          fill={colored ? 'rgb(230, 231, 232)' : '#365284'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 11.5455V7.56763L3.34362 3.81917H20.6564L24 7.56763V11.5455H0Z"
          fill={colored ? '#e6e7e8' : '#365284'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.75684 23.9985V8.54587C2.75684 8.3048 2.84226 8.07359 2.99432 7.90313C3.14637 7.73266 3.35261 7.63689 3.56765 7.63689H20.4325C20.6476 7.63689 20.8538 7.73266 21.0058 7.90313C21.1579 8.07359 21.2433 8.3048 21.2433 8.54587V23.9985H2.75684Z"
          fill={colored ? '#458cf5' : '#365284'}
        />
        <path
          d="M2.75684 11.5455H21.2433V23.9985H2.75684V11.5455Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.7299 23.9985V20.2717L14.1083 18.4538L13.0542 15.1814L13.7839 13.0908L17.9191 17.7266L18.6488 14.2725L21.2434 17.1812V23.9985H15.7299Z"
          fill={colored ? '#d2d3d4' : '#365284'}
        />
        <path
          d="M3.97314 12.9999H10.1353V20.7262H3.97314V12.9999ZM3.97314 22.4533H11.9191V23.9985H3.97314V22.4533Z"
          fill={colored ? '#d2d3d4' : '#36526E'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.2704 21.0989V23.9985H13.865V21.1401C13.1707 20.7858 12.5809 20.2172 12.1645 19.5007C11.7481 18.7842 11.5224 17.9495 11.5139 17.0944C11.5054 16.2393 11.7144 15.3992 12.1164 14.6725C12.5185 13.9457 13.0969 13.3625 13.7839 12.991V17.2721L15.4866 18.4538L17.2704 17.2721V12.9908C17.9507 13.3587 18.5246 13.9343 18.9263 14.6514C19.3279 15.3685 19.5409 16.1981 19.5409 17.0448C19.5409 17.8916 19.3279 18.7212 18.9263 19.4383C18.5246 20.1554 17.9507 20.731 17.2704 21.0989Z"
          fill={colored ? '#505050' : '#36526A'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.66233 8.63677C4.79864 8.63677 4.93189 8.68209 5.04523 8.76698C5.15856 8.85188 5.2469 8.97255 5.29906 9.11373C5.35122 9.25491 5.36487 9.41026 5.33828 9.56014C5.31169 9.71001 5.24605 9.84768 5.14966 9.95574C5.05328 10.0638 4.93048 10.1374 4.79679 10.1672C4.6631 10.197 4.52453 10.1817 4.39859 10.1232C4.27266 10.0647 4.16502 9.96572 4.08929 9.83866C4.01356 9.7116 3.97314 9.56222 3.97314 9.4094C3.97314 9.20449 4.04576 9.00797 4.175 8.86307C4.30425 8.71817 4.47955 8.63677 4.66233 8.63677ZM6.68936 8.63677C6.82567 8.63677 6.95892 8.68209 7.07225 8.76698C7.18559 8.85188 7.27393 8.97255 7.32609 9.11373C7.37825 9.25491 7.3919 9.41026 7.36531 9.56014C7.33872 9.71001 7.27308 9.84768 7.17669 9.95574C7.08031 10.0638 6.9575 10.1374 6.82381 10.1672C6.69013 10.197 6.55155 10.1817 6.42562 10.1232C6.29969 10.0647 6.19205 9.96572 6.11632 9.83866C6.04059 9.7116 6.00017 9.56222 6.00017 9.4094C6.00017 9.20449 6.07278 9.00797 6.20203 8.86307C6.33128 8.71817 6.50658 8.63677 6.68936 8.63677Z"
          fill={colored ? '#e6e7e8' : '#E6E7E8'}
        />
      </g>
      <defs>
        <clipPath id="clip0_1904_57857">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SearchConsoleIcon;
